export default {
  production: process.env.NODE_ENV === 'production',
  storageOptions: {
    namespace: 'pro__',
    name: 'ls',
    storage: 'local'
  }
}
